import React from "react";
import "../styles/component.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";

function LaparoscopicSurgery() {
  return (
          <>
              <section className="general-surgery hide-on-mobile">
                  <img
                      src={require("../assets/img/services/big-2.png")}
                      alt="General Surgery"
                      className="top-band-img"
                  />
              </section>
              <section className="general-surgery-content">
                  <div className="1stblock">
                      <span className="title">What is Laparoscopic & GI Surgery?</span>
                      <p>
                          Laparoscopic and gastrointestinal surgeries use minimally invasive techniques to treat conditions of the digestive system, often involving smaller incisions and reduced recovery time.
                      </p>
                  </div>
                  <div className="general-surgery-row">
                      <div className="general-surgery-col general-surgery-col-1">
                          <span className="subtitle">Procedures Include:</span>
                          <ul className="general-surgery-list">
                              <li>
                                  <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                  Laparoscopic gallbladder surgery
                              </li>
                              <li>
                                  <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                  Diagnostic laparoscopy
                              </li>
                              <li>
                                  <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                  Gastrointestinal surgical procedures
                              </li>
                              {/* <li>
                                  <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                  Intestinal obstruction surgery
                              </li>
                              <li>
                                  <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                  Perforation repair
                              </li>
                              <li>
                                  <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                  Colorectal surgery
                              </li> */}
                          </ul>
                      </div>
                      <div className="general-surgery-col general-surgery-col-2">
                          <span className="subtitle">Why This Service Matters</span>
                          {/* <ul className="general-surgery-list">
                              <li>
                                  <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                  Experienced surgeons
                              </li>
                              <li>
                                  <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                  Well-equipped operation theatres
                              </li>
                              <li>
                                  <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                  ICU and CCU support when required
                              </li>
                              <li>
                                  <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                  Structured post-operative nursing care
                              </li> */}
                              {/* <li>
                                  <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                  Perforation repair
                              </li>
                              <li>
                                  <FontAwesomeIcon icon={faCircleCheck} className="gs-list-icon" />
                                  Colorectal surgery
                              </li> 
                          </ul>*/}
                          <p>Minimally invasive techniques may support patient comfort, shorter hospital stays, and smoother recovery under appropriate medical supervision.</p>
                      </div>
                  </div>
              </section>
              
          </>
      )
}

export default LaparoscopicSurgery;
